import type { IconType } from '@aibees/shared/components';
import { Nullable } from '@aibees/shared/definition';
import type { SxStyle } from '@aibees/shared/theme';
import { SocialLink } from '../search-social-media-item';

export interface SearchSocialMediaProps {
  className?: string;
  sx?: SxStyle;
  socialLink?: Nullable<SocialLink>;
  hideLinkOutIcon?: boolean;
}

export enum SocialMediaType {
  twitter = 'twitter',
  linkedin = 'linkedin',
  facebook = 'facebook',
  instagram = 'instagram',
}

export type SocialMediaItem = {
  color: string;
  icon: IconType;
  type: SocialMediaType;
  prefix: string;
};
